import { createContext } from 'react'
import { DateRange } from '@mui/x-date-pickers-pro'
import { Dayjs } from 'dayjs'

export interface IOnboardingsContext {
  searchQuery: string
  setSearchQuery(value: string): void

  tagsFilter: Array<string>
  setTagsFilter(tagsFilter: Array<string>): void

  dateRange: DateRange<Dayjs>
  setDateRange(dateRange: DateRange<Dayjs>): void
}

export const OnboardingsContext = createContext<IOnboardingsContext>({
  searchQuery: '',
  setSearchQuery: () => {},

  tagsFilter: [],
  setTagsFilter: () => {},

  dateRange: [null, null],
  setDateRange: () => {},
})
